// extracted by mini-css-extract-plugin
export default {"link":"_Y5VeM","list":"plOzfT","message":"kxgKLB","text":"PxL0uF","item":"k9Csnz"};